import { TypographyFontWeightModel, TypographyModel, TypographyVariantModel } from "./tools/Typography.model";
import {
  FontSizeTypeValues,
  FontSizeType,
  handleFontSize,
  lineHeightToFontSize,
  fontText,
  fontDisplay,
  fontDisplayExtraBold,
  StylesIndexInjections
} from "common-react";
import { createStyles, makeUiStyles, Theme } from "../styles/styles";

export const variantToFontSize: Record<
  TypographyVariantModel,
  FontSizeTypeValues
> = {
  special: FontSizeTypeValues.xxxxl,
  h1: FontSizeTypeValues.xxxl,
  h2: FontSizeTypeValues.xxl,
  h3: FontSizeTypeValues.xl,
  h4: FontSizeTypeValues.l,
  body1: FontSizeTypeValues.base,
  body2: FontSizeTypeValues.s,
  body3: FontSizeTypeValues.xs,
  caption: FontSizeTypeValues.xxxlLg,
  subHeadline2: FontSizeTypeValues.subHeadline2,
};

const getFontStyle = (
  variant: TypographyModel["variant"],
  fontWeight: TypographyFontWeightModel,
): string => {
  const fontSizeName = variantToFontSize[variant || 'body1'] || FontSizeTypeValues.base;
  const fontSizeValue = handleFontSize(fontSizeName as FontSizeType);
  const lineHeight =
    lineHeightToFontSize[fontSizeName as keyof typeof lineHeightToFontSize];

  if (fontWeight === 'extraBold') {
    return fontDisplayExtraBold('normal', fontSizeValue, lineHeight);
  }

  return fontWeight === 'bold'
    ? fontDisplay('normal', fontSizeValue, lineHeight)
    : fontText('normal', fontSizeValue, lineHeight);
};

export const getTextColor = (
  textColor: TypographyModel["textColor"],
  theme: Theme
): string =>
  textColor
    ? textColor.split('.').reduce<any>((acc, key) => acc[key], theme.color)
    : theme.color.greys[80];

export default makeUiStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        color: ({ textColor }: TypographyModel) =>
          getTextColor(textColor, theme),
        font: ({ variant, fontWeight }: TypographyModel) =>
          getFontStyle(variant, fontWeight || 'normal'),
      },
    }),
  { name: "Typography", index: StylesIndexInjections.UI_ATOMS }
);
